import { useEffect } from 'react';
import { ClientLocationDto } from '@/app/store/api/restApi';
import { setCityCoords, useAppDispatch } from '@/app/store';

export const useActualiseCityCoords = ({
  locations,
  locationsLoading,
}: {
  locationsLoading: boolean;
  locations: ClientLocationDto[];
}) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!locationsLoading) {
      const deliveryLocations = locations.filter((l) => l.delivery?.isActive);
      const cityNames = deliveryLocations.map((l) => l.address.split(',')[0]);
      const inOneCity = cityNames.every((val) => val === cityNames[0]);

      if (deliveryLocations.length > 0 && inOneCity) {
        let lat = 0;
        let lng = 0;
        for (const loc of deliveryLocations) {
          lat += loc.coordinates.lat;
          lng += loc.coordinates.lng;
        }

        lat /= deliveryLocations.length;
        lng /= deliveryLocations.length;

        dispatch(setCityCoords({ lat, lng }));
      } else dispatch(setCityCoords(undefined));
    }
  }, [dispatch, locations, locationsLoading]);
};
